// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@conklin/App/Store/Reducers";
import Link from "@conklin/MobiusOverrides/Link/Link";
import { xMask } from "@conklin/XDL/Utilities";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { LinkPresentationProps } from "@insite/mobius/Link";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: CustomAppState) => ({
    pickUpWarehouse: getSession(state).pickUpWarehouse,
});

export interface HeaderBranchPhoneNumberStyles {
    phoneLink?: LinkPresentationProps;
}

export const headerBranchPhoneNumberStyles: HeaderBranchPhoneNumberStyles = {};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;
const styles = headerBranchPhoneNumberStyles;

const HeaderBranchPhoneNumber: FC<Props> = ({ pickUpWarehouse }) => {
    if (!pickUpWarehouse || !pickUpWarehouse.phone) {
        return null;
    }

    return (
        <Link {...styles.phoneLink} href={`tel:${pickUpWarehouse.phone}`}>
            {xMask.addressPhone(pickUpWarehouse.phone)}
        </Link>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(HeaderBranchPhoneNumber),
    definition: {
        displayName: "Header Branch Phone Number",
        fieldDefinitions: [],
        group: "Header",
        allowedContexts: ["Header"],
    },
};

export default widgetModule;
